import React, { useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Text, Button, Image
} from 'components/ui';
import localeUtils from 'utils/LanguageLocale';

import SmsTextOptInAlertBannerEN from 'components/SmsTextOptInAlertBanner/locales/SmsTextOptInAlertBanner_en_US';
import SmsTextOptInAlertBannerFR from 'components/SmsTextOptInAlertBanner/locales/SmsTextOptInAlertBanner_fr_CA';

import SmsOptInModal from 'components/SmsOptInModal';

const SmsTextOptInAlertBanner = ({ marginBottom, smsTextOptInPromos, isUserOptedIn, ...rest }) => {
    // Fallback Default image and label for the banner.
    const getText = localeUtils.getLocalisedDataFromResource(SmsTextOptInAlertBannerEN, SmsTextOptInAlertBannerFR);
    const imgSrc = '/img/ufe/sms-opt-in-modal-icon.svg';

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleContinue = () => {
        // Make API call to subscribe user
        setIsModalOpen(false);
    };

    const handleDismiss = () => {
        setIsModalOpen(false);
    };

    const shouldDisplayBanner = () => {
        // Should Check the Kill Switch to determine if the banner should be shown or not
        const smsOptInKillSwitchEnabled = Sephora.configurationSettings?.sms?.orderConfirmationOptInModal?.isEnabled || false; // Default state to show current banner/modal.

        return smsOptInKillSwitchEnabled && !isUserOptedIn;
    };

    const getBannerLabel = () => {
        const fallBackBannerLabel = getText('description');

        if (smsTextOptInPromos && smsTextOptInPromos.promos && smsTextOptInPromos.promos.length > 0) {
            const latestPromo = smsTextOptInPromos.promos[0] || ''; // Assuming the latest promo is the first one in the array

            return latestPromo !== '' ? latestPromo.promoBannerDescription : fallBackBannerLabel; // Use the promo title if available
        }

        return fallBackBannerLabel;
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsModalOpen(true);
        }
    };

    return !shouldDisplayBanner() ? null : (
        <>
            <Box
                backgroundColor='lightBlue'
                borderRadius={2}
                padding={4}
                marginBottom={marginBottom || 4}
                display='flex'
                flexDirection={['column', 'row']}
                alignItems={['flex-start', 'center']}
                justifyContent='space-between'
                gap={3}
                width='100%'
                onClick={() => setIsModalOpen(true)}
                onKeyDown={handleKeyDown}
                role='button'
                aria-label={getText('buttonText')}
                data-at={Sephora.debug.dataAt('sms_text_alert_banner')}
                {...rest}
            >
                <Flex
                    alignItems='center'
                    gap={3}
                    flex={1}
                >
                    <Box
                        width={48}
                        height={48}
                        flexShrink={0}
                        borderRadius={2}
                        display='flex'
                        alignItems='center'
                        justifyContent='center'
                        position='relative'
                    >
                        <Image src={imgSrc} />
                    </Box>
                    <Box flex={1}>
                        <Text
                            is='h3'
                            fontSize='md'
                            fontWeight='bold'
                            marginBottom={0}
                            data-at={Sephora.debug.dataAt('sms_text_alert_banner_title')}
                        >
                            {getText('title')}
                        </Text>
                        <Text
                            fontSize='md'
                            color='black'
                            data-at={Sephora.debug.dataAt('sms_text_alert_banner_description')}
                        >
                            {getBannerLabel()}
                        </Text>
                    </Box>
                </Flex>
                <Button
                    variant='secondary'
                    onClick={e => {
                        e.stopPropagation();
                        setIsModalOpen(true);
                    }}
                    width={['100%', 'auto']}
                    whiteSpace='nowrap'
                    backgroundColor='white'
                    data-at={Sephora.debug.dataAt('sms_text_alert_banner_button')}
                >
                    {getText('buttonText')}
                </Button>
            </Box>
            <SmsOptInModal
                isUserOptedIn={isUserOptedIn}
                smsTextOptInPromos={smsTextOptInPromos}
                isOpen={isModalOpen}
                onDismiss={handleDismiss}
                onContinue={handleContinue}
            />
        </>
    );
};

export default wrapFunctionalComponent(SmsTextOptInAlertBanner, 'SmsTextOptInAlertBanner');
